import { Star } from "lucide-react";
import { SupplierRating } from "../types";

interface RatingCellProps {
  ratings: SupplierRating[];
}

export const RatingCell = ({ ratings }: RatingCellProps) => {
  const getLatestRating = (ratings: SupplierRating[]) => {
    if (!ratings || ratings.length === 0) return null;
    return ratings[0].rating;
  };

  const rating = getLatestRating(ratings);
  
  return rating ? (
    <div className="flex items-center">
      <Star className="h-4 w-4 text-yellow-400 mr-1" />
      <span>{rating}/5</span>
    </div>
  ) : "-";
};